import * as React from 'react'

import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useGetChurnRequests } from 'modules/billing/hooks/churn_request/useGetChurnRequests'

import DeleteCompanyModal from './_DeleteCompanyModal'

const OngoingCompanyDeletion = () => {
  return (
    <Box width="full" padding="s40" alignItems="center">
      <Text.Normal color="radicalRed1000" size="300">
        {i18n.t('common.cancel_company_subscription.ongoing_deletion')}
      </Text.Normal>
    </Box>
  )
}

const DeleteCompanyAction = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const { churnRequests, loading } = useGetChurnRequests({})
  const ongoingDeletion = !!churnRequests?.length
  const boxProps = ongoingDeletion
    ? {
        component: 'div' as const,
      }
    : {
        component: 'button' as const,
      }

  if (ongoingDeletion) {
    return <OngoingCompanyDeletion />
  }

  if (loading) return <Spinner />

  return (
    <>
      <Box width="full" padding="s40" alignItems="center">
        <Box
          background="grey200"
          paddingY="s8"
          paddingX="s16"
          borderRadius={{ all: 'abs100' }}
          {...boxProps}
          onClick={() => setIsModalOpen(true)}
        >
          <Text.Normal color="radicalRed1200" size="200">
            {i18n.t('common.cancel_company_subscription.button.cancel')}
          </Text.Normal>
        </Box>
      </Box>
      {isModalOpen && <DeleteCompanyModal onClose={() => setIsModalOpen(false)} />}
    </>
  )
}

export default DeleteCompanyAction
